<div class="plan-details-section">
  <h1 class="title">Viewing Your Plan Details:</h1>
  <div class="selected-plan-container page-section">
    <div class="base-background">
      <img src="/assets/img/freeup-mobile-frame.svg" alt="frame-img" width="294" height="308"
        class="freeup-mobile-frame">
    </div>
    <div class="selected-plan-card">
      <div *ngIf="selectedPlan?.subscriptionCycles === 3" class="intro-offer">
        <img src="/assets/icon/special-offer.svg" width="230" height="24" alt="intro-offer">
        <p class="footer intro">Special Offer, Intro Prices!</p>
      </div>
      <div class="internal-card-padding">
        <div class="top-card-section">
          <div class="card-header">
            <h4 class="plan-data" *ngIf="selectedPlan?.details?.data > 0">{{selectedPlan?.subscriptionCycles}}-Month
              <b>{{selectedPlan?.details?.data/1024 < 1 ? selectedPlan?.details?.data + 'MB ' :
                  selectedPlan?.details?.data/1024 + 'GB ' }}</b>plan
            </h4>
            <h4 class="plan-data" *ngIf="selectedPlan?.details?.data<=0">{{selectedPlan?.subscriptionCycles}}-Month
              <b>Talk & Text</b>
            </h4>
          </div>
          <h1 class="plan-card-price"><sup class="dollar">$</sup>{{!!selectedPlan?.promoMoPrice ?
            selectedPlan?.promoMoPrice : selectedPlan?.price}}<span class="mo"> /mo</span></h1>
        </div>
        <div class="card-content">
          <ul class="plan-details">
            <li class="detail">
              <img width="13" height="24" src="/assets/icon/yellow-tick.svg" alt="Plan Detail Icon">
              <p class="smaller text"><b>Unlimited</b> talk and text <span *ngIf="selectedPlan?.details?.data > 0">+
                  data</span> access on America’s best nationwide <b>5G</b>.</p>
            </li>
            <li class="detail" *ngIf="selectedPlan?.details?.data > 0">
              <img width="13" height="24" src="/assets/icon/yellow-tick.svg" alt="Plan Detail Icon">
              <p class="smaller text"><b>{{selectedPlan?.details?.data/1024 < 1 ? selectedPlan?.details?.data + 'MB ' :
                    selectedPlan?.details?.data/1024 + 'GB ' }}</b>high-speed data per month; then slowed (no
                    overage).</p>
            </li>
            <li class="detail">
              <img width="13" height="24" src="/assets/icon/yellow-tick.svg" alt="Plan Detail Icon">
              <p class="smaller text"><b>FREE </b> SIM Card Activation Kit. <b>FREE</b> Shipping.</p>
            </li>
            <li class="detail">
              <img width="13" height="24" src="/assets/icon/yellow-tick.svg" alt="Plan Detail Icon">
              <p class="smaller text">Enjoy <b>Unlimited</b> Global Talk to over <b><a (click)="showCountries()">60+
                    destinations</a></b>.</p>
            </li>
            <li class="detail last">
              <img width="13" height="24" src="/assets/icon/yellow-tick.svg" alt="Plan Detail Icon">
              <p class="smaller text">Works with <b>AT&T</b> and compatible <b>unlocked</b> phones.</p>
            </li>
          </ul>
        </div>
        <div class="action">
          <p class="subtotal">Subtotal: <b>${{!!selectedPlan?.promoMoPrice ? selectedPlan?.promoMoPrice *
              selectedPlan?.subscriptionCycles: selectedPlan?.price * selectedPlan?.subscriptionCycles}}</b></p>
          <button class="button primary" (click)="addPlanToCart()" id="add-{{selectedPlan?.id}}-to-cart">Add to
            Cart</button>
        </div>
      </div>
    </div>
  </div>
  <section class="page-section">
    <div class="reminder-card">
      <img src="assets/icon/reminder.svg" alt="reminder" width="32" height="32" class="reminder-icon">
      <div class="card-contents">
        <h4 class="main-title">Remember to..</h4>
        <p class="smaller desc">Set up your Auto Renewal when subscribing to any monthly plan and enjoy a hassle-free
          plan renewal!</p>
      </div>
    </div>
  </section>
  <div class="other-suggested-plans-section" *ngIf="filteredPlans?.length > 0">
    <h2 class="title">Other Suggested Plans:</h2>
    <h5 class="desc" [innerHTML]="suggestedPlanDesc"></h5>
    <div class="plan-cards-part">
      <div class="suggested-plans-desktop">
        <div class="plan-card" *ngFor="let plan of filteredPlans;let i = index;">
          <div *ngIf="plan?.subscriptionCycles === 3" class="intro-offer">
            <img src="/assets/icon/special-offer.svg" width="230" height="24" alt="intro-offer">
            <p class="footer intro">Special Offer, Intro Prices!</p>
          </div>
          <div class="price-details">
            <div class="data-part" [class.talk-and-text]="plan?.details?.data <= 0">
              <p class="value" *ngIf="plan?.details?.data > 0">
                <b>{{plan?.details?.data/1024 < 1 ? plan?.details?.data : plan?.details?.data/1024 }}<span
                    class="gigs-val">{{plan?.details?.data/1024 < 1 ? 'MB ' : 'GB ' }}</span>
                </b>
              </p>
              <p class="value min-line-height" *ngIf="plan?.details?.data <= 0">
                <b>Talk & Text</b>
              </p>
              <p class="caption">Premium 5G Data</p>
            </div>
            <div class="border"></div>
            <div class="price-part">
              <p class="value"><sup>$</sup>{{!!plan?.promoMoPrice ? plan?.promoMoPrice :
                plan?.price}}</p>
              <p class="caption">Per month</p>
            </div>
          </div>
          <p class="footer disclaimer">Subscription will auto renew at <b>${{plan?.price * plan?.subscriptionCycles}}
              +</b> applicable taxes & fees.</p>
          <div class="subtotal-section">
            <p class="smaller subtotal">Subtotal:</p>
            <p><b>${{!!plan?.promoMoPrice ? plan?.promoMoPrice *
                plan?.subscriptionCycles: plan?.price * plan?.subscriptionCycles}}</b></p>
          </div>
          <div class="action">
            <button class="button primary" (click)="addPlanToCart(plan)" id="add-{{plan?.id}}-to-cart">Add to
              Cart</button>
          </div>
        </div>
      </div>
      <div class="swiper-container main-plans">
        <div class="swiper-wrapper">
          <ng-container *ngFor="let plan of filteredPlans;let i = index;">
            <div class="swiper-slide plan-card">
              <div *ngIf="plan?.subscriptionCycles === 3" class="intro-offer">
                <img src="/assets/icon/special-offer.svg" width="162" height="24" alt="intro-offer">
                <p class="footer intro">Special Offer, Intro Prices!</p>
              </div>
              <div class="price-details">
                <div class="data-part" [class.talk-and-text]="plan?.details?.data <= 0">
                  <p class="value" *ngIf="plan?.details?.data > 0">
                    <b>{{plan?.details?.data/1024 < 1 ? plan?.details?.data : plan?.details?.data/1024 }}<span
                        class="gigs-val">{{plan?.details?.data/1024 < 1 ? 'MB ' : 'GB ' }}</span>
                    </b>
                  </p>
                  <p class="value min-line-height" *ngIf="plan?.details?.data <= 0">
                    <b>Talk & Text</b>
                  </p>
                  <p class="caption">Premium 5G Data</p>
                </div>
                <div class="border"></div>
                <div class="price-part">
                  <p class="value"><sup>$</sup>{{!!plan?.promoMoPrice ? plan?.promoMoPrice :
                    plan?.price}}</p>
                  <p class="caption">Per month</p>
                </div>
              </div>
              <p class="footer disclaimer">Subscription will auto renew at <b>${{plan?.price *
                  plan?.subscriptionCycles}} +</b> applicable taxes & fees.</p>
              <div class="subtotal-section">
                <p class="smaller subtotal">Subtotal:</p>
                <p><b>${{!!plan?.promoMoPrice ? plan?.promoMoPrice *
                    plan?.subscriptionCycles: plan?.price * plan?.subscriptionCycles}}</b></p>
              </div>
              <div class="action">
                <button class="button primary" (click)="addPlanToCart(plan)" id="add-{{plan?.id}}-to-cart">Add to
                  Cart</button>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="hand-swiper">
          <img src="/assets/icon/hand-swipe.svg" alt="hand-swipe" width="32" height="32">
          <p class="caption swipe-note">Swipe right</p>
        </div>
        <ul class="slick-dots plan-dots slider-pagination"></ul>
      </div>
    </div>
  </div>
  <div class="faqs-section-details page-section">
    <h2 class="main-title">FAQs</h2>
    <h5 class="subtitle">Got question? We got answers!</h5>
    <div *ngFor="let item of plansFaqs | async">
      <div *ngFor="let qst of item?.fields?.questions">
        <app-question-answer question="{{qst?.fields?.questionText}}" [id]="qst?.fields?.questionId"
          [class.active]="qst?.fields?.questionId == questionId" [isActive]="qst?.fields?.questionId == questionId"
          (click)="toggleActive(qst?.fields?.questionId,qst?.fields?.answerId)">
          <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
        </app-question-answer>
      </div>
    </div>
  </div>
</div>